(function () {
  const popups = document.querySelectorAll(".simple-popup");
  if (!popups.length) return;

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name +
      "=" +
      encodeURIComponent(value) +
      "; expires=" +
      d.toUTCString() +
      "; path=/; SameSite=Lax";
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function initPopup(popup) {
    const popupId = String(popup.dataset.popupId || "default");
    const delaySeconds = Number(popup.dataset.delaySeconds || 3);
    const showOnce = popup.dataset.showOnce === "true";
    const cookieDays = Number(popup.dataset.cookieDays || 1);

    const COOKIE_NAME = `simple_popup_shown__${popupId}`;
    let shownThisPage = false;

    const closeEls = popup.querySelectorAll("[data-simple-popup-close]");

    function open() {
      if (shownThisPage) return;
      if (showOnce && getCookie(COOKIE_NAME)) return;

      shownThisPage = true;
      popup.hidden = false;
      popup.setAttribute("aria-hidden", "false");

      if (showOnce) setCookie(COOKIE_NAME, "1", cookieDays);
    }

    function close() {
      popup.hidden = true;
      popup.setAttribute("aria-hidden", "true");
      if (showOnce) setCookie(COOKIE_NAME, "1", cookieDays);
    }

    closeEls.forEach((el) => el.addEventListener("click", close));
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });

    setTimeout(open, Math.max(0, delaySeconds) * 1000);
  }

  popups.forEach(initPopup);
})();
